module.exports = __webpack_public_path__ + "static/media/download.fab5201a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/download.svg
// module id = 877
// module chunks = 0